import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminsAddEditUserModal = (props: {
    active: boolean,
    closeHandler: any,
    isEdit: boolean,
    id: number,
    onDone: any
}) => {
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [tell, setTell] = useState('');
    const [pass, setPass] = useState('');
    const [role, setRole] = useState('');
    const [err, setErr] = useState({
        firstname: false,
        lastname: false,
        tell: false,
        pass: false,
        role: false,
    });
    const fetchData = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/users/get',
            {
                id: props.id.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string,
                firstname: string,
                lastname: string,
                tell: string,
                role: string,
                pass: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if (d.reason === 'access') {
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        props.closeHandler();
                    }
                    return;
                }
                setFirstname(d.firstname);
                setLastname(d.lastname);
                setRole(d.role);
                setTell(d.tell.replaceAll('+98', '0'));
                setPass(d.pass);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        const isEdit = props.isEdit;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            if (isEdit) {
                fetchData();
            } else {
                setFirstname('');
                setLastname('');
                setPass('');
                setRole('');
                setTell('');
            }
            setErr({
                firstname: false,
                tell: false,
                pass: false,
                role: false,
                lastname: false,
            });
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const ids = {
        firstname:useId(),
        lastname:useId(),
        tell:useId(),
        role:useId(),
        pass:useId(),
    };
    const saveChanges = () => {
        let data = {
            firstname:firstname.trim(),
            lastname:lastname.trim(),
            tell:tell.trim(),
            pass:pass.trim(),
            role:role.trim(),
        };
        let errors = {
            firstname: false,
            lastname: false,
            tell: false,
            pass: false,
            role: false,
        };
        let stop = false;
        if(data.firstname.length < 2){
            errors.firstname = true;
            stop = true;
        }
        if(data.lastname.length < 2){
            errors.lastname = true;
            stop = true;
        }
        if(data.tell.length !== 11){
            errors.tell = true;
            stop = true;
        }
        if(data.role.length < 2){
            errors.role = true;
            stop = true;
        }
        if(data.pass.length < 3){
            errors.pass = true;
            stop = true;
        }
        setErr(errors);
        if(stop)
            return;
        data.tell = '+98' + data.tell.substring(1);
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/users/' + (props.isEdit ? 'edit':'add'),
            {
                id:props.id.toString(),
                firstname:data.firstname,
                lastname:data.lastname,
                tell:data.tell,
                role:data.role,
                password:data.pass,
            },
            true,
            (d: {
                result: string,
                reason: string,
                id:number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if(d.reason === 'exists'){
                        ShowSnackbar(
                            'شماره تلفن تکراری می‌باشد.',
                            'باشه',
                            5000,
                        );
                    }
                    else if (d.reason === 'access') {
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        props.closeHandler();
                    }
                    return;
                }
                ShowSnackbar(
                    props.isEdit ? 'کاربر ویرایش شد.' : 'کاربر جدید افزوده شد.',
                    'باشه',
                    5000,
                );
                props.closeHandler();
                props.onDone();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top:20}}>
                <div className="web-modal-header">
                    <div><b>{props.isEdit ? 'ویرایش کاربر' : 'کاربر جدید'}</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label htmlFor={ids.firstname}>نام:</label>
                        <input type="text"
                               className={"form-control" + (err.firstname ? ' is-invalid' : '')}
                               value={firstname}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setFirstname(t);
                                   setErr(v => {
                                       let x = {...v};
                                       x.firstname = false;
                                       return x;
                                   });
                               }}
                        />
                        <div className={"invalid-feedback" + (err.firstname ? ' d-block' : ' d-none')}>
                            لطفا حداقل ۲ کاراکتر وارد کنید.
                        </div>
                        <div style={{height: 20}}/>
                        <label htmlFor={ids.lastname}>نام خانوادگی:</label>
                        <input type="text"
                               className={"form-control" + (err.lastname ? ' is-invalid' : '')}
                               value={lastname}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setLastname(t);
                                   setErr(v => {
                                       let x = {...v};
                                       x.lastname = false;
                                       return x;
                                   });
                               }}
                        />
                        <div className={"invalid-feedback" + (err.lastname ? ' d-block' : ' d-none')}>
                            لطفا حداقل ۲ کاراکتر وارد کنید.
                        </div>
                        <div style={{height: 20}}/>
                        <label htmlFor={ids.tell}>تلفن همراه:</label>
                        <input type="text"
                               className={"form-control" + (err.tell ? ' is-invalid' : '')}
                               value={tell}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setTell(t);
                                   setErr(v => {
                                       let x = {...v};
                                       x.tell = false;
                                       return x;
                                   });
                               }}
                        />
                        <div className={"invalid-feedback" + (err.tell ? ' d-block' : ' d-none')}>
                            لطفا تلفن همراه را بصورت ۱۱ رقمی با صفر اول وارد نمایید.
                        </div>
                        <div style={{height: 20}}/>
                        <label htmlFor={ids.pass}>گذرواژه:</label>
                        <input type="password"
                               className={"form-control" + (err.pass ? ' is-invalid' : '')}
                               value={pass}
                               onChange={e => {
                                   const t = e.currentTarget.value.trim();
                                   setPass(t);
                                   setErr(v => {
                                       let x = {...v};
                                       x.pass = false;
                                       return x;
                                   });
                               }}
                        />
                        <div className={"invalid-feedback" + (err.pass ? ' d-block' : ' d-none')}>
                            لطفا حداقل ۳ کاراکتر وارد کنید.
                        </div>
                        <div style={{height: 20}}/>
                        <label htmlFor={ids.role}>سمت:</label>
                        <input type="text"
                               className={"form-control" + (err.role ? ' is-invalid' : '')}
                               value={role}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setRole(t);
                                   setErr(v => {
                                       let x = {...v};
                                       x.role = false;
                                       return x;
                                   });
                               }}
                        />
                        <div className={"invalid-feedback" + (err.role ? ' d-block' : ' d-none')}>
                            لطفا حداقل ۲ کاراکتر وارد کنید.
                        </div>
                        <div style={{height: 20}}/>
                        <div className="d-flex justify-content-end align-items-center" style={{gap:5}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={saveChanges}>
                                <b>ذخیره تغییرات</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};